import { Coffee, UtensilsCrossed, BookOpen, Hourglass } from "lucide-react";

export const PALETTE = ["#FCA5A5", "#86EFAC", "#FDE047", "#D8B4FE", "#7DD3FC", "#A7E4D3", "#FDBA74", "#C7D2FE"];
export const TYPE_STYLE = { break: "#FDE68A88", lunch: "#F9A8D488", free: "#C7D2FE88" };
export const TYPES = [
  { value: "period", label: "Period", icon: BookOpen, bg: "#A7E4D3" },
  { value: "break", label: "Break", icon: Coffee, bg: "#FDE68A" },
  { value: "lunch", label: "Lunch", icon: UtensilsCrossed, bg: "#F9A8D4" },
  { value: "free", label: "Free", icon: Hourglass, bg: "#C7D2FE" },
];
export const ALL_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export function subjectColor(name) {
  let h = 0;
  for (const ch of name || "") h = (h * 31 + ch.charCodeAt(0)) % 997;
  return PALETTE[h % PALETTE.length];
}
